// extracted by mini-css-extract-plugin
module.exports = {"container":"i_PH","navigation":"i_PI","body":"i_PJ","offset":"i_PK","icons":"i_PL","left":"i_PM","right":"i_PN","slot":"i_PO","icon":"i_PP","wrapper":"i_PQ","logo":"i_PR"};